import { StrollrEventType } from '@enums/strollr-event-type.enum';
import { ProjectSelection } from '@modules/project-selection';
import StrollEventService from '@services/strollr-event.service';
import { Button, useTranslation } from '@testsigma/atoms';
import { useCallback, useState } from 'react';

interface InvitedUserOnboardingProps {
  switchToProjectWithVersionId: (
    applicationVersionId: number,
    isCreateNew: boolean,
  ) => void;
}

export const InvitedUserOnboarding: React.FC<InvitedUserOnboardingProps> = ({
  switchToProjectWithVersionId,
}) => {
  const { t } = useTranslation();

  const [applicationVersionId, setApplicationVersionId] =
    useState<number>(null);

  const onClickContinue = useCallback(() => {
    switchToProjectWithVersionId(applicationVersionId, false);
    sendStrollrTrackEventForExistingProject();
  }, [switchToProjectWithVersionId, applicationVersionId]);

  // send track event to strollr application fro sample project selection
  const sendStrollrTrackEventForExistingProject = () => {
    StrollEventService.track(StrollrEventType.COMMON_SAMPLE_PROJECT_CLICK);
  };

  return (
    <div className='mx-10 mt-20 w-[56%] flex flex-col'>
      {/* Welcome to Testsigma! */}
      <div className=' text-xl font-medium text-unique-600'>
        {t('commmon.welcome.note')}
      </div>

      {/* Introduction text  */}
      <div className='text-sm font-normal text-secondary-500 mt-2'>
        {t('commmon.try.projects')}
      </div>

      {/* Project selection  */}
      <div className='mt-4'>
        <ProjectSelection
          applicationVersionId={applicationVersionId}
          onChangeApplicationVerisonId={setApplicationVersionId}
          projectAutoCompleteClassName='!w-1/2 !pr-1.5'
          variant='runtime-test-data'
        />
      </div>

      {/* Button */}
      <div className='mt-10 ml-1 flex'>
        <Button
          type='primary'
          onClick={onClickContinue}
          isDisabled={!applicationVersionId}>
          <div className='flex justify-center items-center gap-x-2'>
            <div>{t('common.continue')}</div>
          </div>
        </Button>
      </div>
    </div>
  );
};
